import { BaseModel } from "../Generics/BaseModel"
import { GenericFoodEntity } from "./GenericFoodEntity"

export class DrinkEntity extends BaseModel {
  id: number
  genericFoodEntity: GenericFoodEntity

  constructor(data: Partial<DrinkEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.genericFoodEntity = new GenericFoodEntity(data.genericFoodEntity)
  }
}
